import { ReactNode, useState } from "react"
// context
import PlayerContext from "./context"

type VideoLanguageProviderProps = {
  children: ReactNode
}

const VideoLanguageProvider = ({ children }: VideoLanguageProviderProps) => {
  const [changedEntryPlayerId, setEntryPlayerId] = useState("")
  const [changedEpisodeDocumentId, setEpisodeDocumentId] = useState("")

  return (
    <PlayerContext.Provider
      value={{ changedEntryPlayerId, setEntryPlayerId, changedEpisodeDocumentId, setEpisodeDocumentId }}
    >
      {children}
    </PlayerContext.Provider>
  )
}

export default VideoLanguageProvider
